import styled from 'styled-components'

export const SubTextStyle = styled.div`
  font-size: small;
  font-weight: normal;
  padding-top: 0.5em;

  }
  @media (max-width: 600px) {
    .cellheader {
      font-size: large;
    }
    font-size: small;
    padding-top: 0.5em;

  }
`
